import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Formik, Form } from 'formik';
import { Button } from 'primereact/button';
import { General, EmailTemplates } from './EditFormSection';
import useSubscriptionExpiredRestrictions from '../../../../../hooks/useSubscriptionExpiredRestrictions';

const Edit = ({ editing, closeEditForm, saveData, communications, initialValues }) => {
  const { subscriptionIsExpired } = useSubscriptionExpiredRestrictions();

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={async (formValues, { setSubmitting }) => {
        saveData(formValues);
        setSubmitting(false);
      }}
    >
      {({ isSubmitting, resetForm }) => {
        return (
          <Form>
            <General editing={editing} />
            <EmailTemplates templates={communications} editing={editing} />
            {editing ? (
              <div className="p-grid">
                <div className="p-col-12">
                  <FormattedMessage id="actions.save" defaultMessage="Save">
                    {(text) => <Button type="submit" disabled={isSubmitting || subscriptionIsExpired} label={text} />}
                  </FormattedMessage>
                  &nbsp;
                  <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
                    {(text) => (
                      <Button
                        type="button"
                        className="p-button-raised p-button-secondary"
                        onClick={() => {
                          closeEditForm(resetForm);
                        }}
                        disabled={isSubmitting}
                        label={text}
                      />
                    )}
                  </FormattedMessage>
                </div>
              </div>
            ) : null}
          </Form>
        );
      }}
    </Formik>
  );
};

Edit.propTypes = {
  editing: PropTypes.bool.isRequired,
  closeEditForm: PropTypes.func.isRequired,
  saveData: PropTypes.func.isRequired,
  communications: PropTypes.objectOf(PropTypes.any).isRequired,
  initialValues: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Edit;
